export interface BulkOperationErroredItem {
    id: number;
    reason: string;
    errorDateUTC: string;
}

export enum BulkOperationTargetEnum {
    Offer = "offer",
    SponsoredAd = "sponsoredAd",
}

export type BulkOperationTarget = `${BulkOperationTargetEnum}`;

export enum BulkOperationOperationTypeEnum {
    Cancel = "cancel",
    Restart = "restart",
    Edit = "edit",
}

export type BulkOperationOperationType = `${BulkOperationOperationTypeEnum}`;

export type BulkOperationStatus = "pending" | "inProgress" | "done" | "failed";

export interface BulkOperation {
    id: number;
    target: BulkOperationTarget;
    operationType: BulkOperationOperationType;
    status: BulkOperationStatus;
    userId: number;
    organizationId: number;
    totalItems: number;
    processedItems: number;
    erroredItems: BulkOperationErroredItem[];
    operationIdList: number[];
    metadata: Record<string, unknown> | null;
    processedDateUTC: string | null;
    endedDateUTC: string | null;
    seenDateUTC: string | null;
    createdDateUTC: string;
    updatedDateUTC: string;
}
